import React from 'react'

const Thankyou = () => {
  return (
    <div className="bg-gray-100 min-h-screen relative">
         <div className="w-1/2 bg-white p-4 rounded-xl shadow-2xl absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2">      
                    <p className="text-lg text-center font-semibold">Thank you for your application. Please check your email for next steps, ensure to check your spam folders also.</p>
                    <div className="text-center">
                    </div>
                </div>
    </div>
  )
}

export default Thankyou